import React, { Component } from "react";
import {
  BrowserRouter,
  HashRouter,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import Rotation from "react-rotation";
import RendersDAO from "./services/renders.dao";
import Camera from "./components/camera/camera.component";

import { connect } from "react-redux";

import Ingreso from "./components/ingreso.component";
import Canvas from "./components/canvas.component";
import { INGRESO_ROUTE, MAQUETA_ROUTE } from "./config/routes";

import bg from './UI/RotationScreen/Spin360_General_034.png'
import logoCastelo from './UI/RotationScreen/logo-castelo.svg'
import rotation from './UI/RotationScreen/rotation.png'

// const images = importAll(require.context("./img", false, /\.png/));


const AuthRoute = ({ component: Component, authUser, ...rest }) => {
    
    return (
      <Route
        {...rest}
        render={(props) =>
            Object.keys(authUser).length != 0 ? (
                <Route path={MAQUETA_ROUTE} component={Canvas} />
            ) : (
              <Redirect
                to={{
                  pathname: '/',
                  state: { from: props.location },
                }}
              />
            )
          }
      />
    );
  }

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      image: "",
    };
  }

  componentDidMount() {
    
  }

  render() {
    const items = [];
    // for(let i = 0; i<120; i++){
    //     items.push(<img alt="" src={images[i+'.png']} />);
    // }
    //console.log(this.props.proyecto);
    return (
      <HashRouter>
        <div className="portrait-rotation">
          <img src={bg} className="background-portrait"></img>
          <div className="cover-portrait">
            <img src={logoCastelo} className="logo-castelo-portrait"></img>
            <img src={rotation} className="rotation-portrait"></img>
            <div className="text-portrait">
              <p className="p-text-portrait">ROTA TU DISPOSITIVO</p>
              <p className="s-text-portrait">para disfrutar la experiencia</p>
            </div>
          </div>
        </div>
        <div>
          <Switch>
          <AuthRoute
                    path="/maqueta-web"
                    authUser={this.props.proyecto}
                    component={Canvas}
                  />
            <Route path={INGRESO_ROUTE} component={Ingreso} exact />
            <Route path={MAQUETA_ROUTE} component={Canvas} />

          </Switch>
        </div>
      </HashRouter>

      // <div>
      // <h1>
      //     test base64
      // </h1>
      // {/* <Camera></Camera> */}
      // </div>
    );
  }
}

const mapStateToProps = ({ welcomeReducer }) => {
    const {
        proyecto
      } = welcomeReducer;
      return { proyecto };;
  };
  
  export default connect(
    mapStateToProps
  )(App);

